import ManseTable from './ManseTable.jsx';

// 진행 화면의 사주 원국 카드 (만세력 스타일 작은 표)
export default function PillarsCard({ saju }) {
  return (
    <section className="panel">
      <h3>사주 원국</h3>
      <ManseTable saju={saju} compact />
    </section>
  );
}
